import { useEffect } from "react";
import { set, useFormContext, useWatch } from "react-hook-form";

const ENRICHMENT_PRESETS = {
  500: {
    unitAmount: 1200,
    dollars: 12,
    hasListEnrichment: true,
    hasFreeListEnrichment: false,
    hasEventIntelligence: false,
  },
  1000: {
    unitAmount: 1050,
    dollars: 10.5,
    hasListEnrichment: true,
    hasFreeListEnrichment: false,
    hasEventIntelligence: false,
  },
  2500: {
    unitAmount: 700,
    dollars: 7,
    hasListEnrichment: true,
    hasFreeListEnrichment: false,
    hasEventIntelligence: false,
  },
  5000: {
    unitAmount: 500,
    dollars: 5,
    hasListEnrichment: true,
    hasFreeListEnrichment: false,
    hasEventIntelligence: false,
  },
  10000: {
    unitAmount: 365,
    dollars: 3.65,
    hasListEnrichment: true,
    hasFreeListEnrichment: false,
    hasEventIntelligence: false,
  },
  20000: {
    unitAmount: 265,
    dollars: 2.65,
    hasListEnrichment: true,
    hasFreeListEnrichment: false,
    hasEventIntelligence: false,
  },
  50000: {
    unitAmount: 137,
    dollars: 1.37,
    hasListEnrichment: true,
    hasFreeListEnrichment: false,
    hasEventIntelligence: false,
  },
  100000: {
    unitAmount: 99,
    dollars: 0.99,
    hasListEnrichment: true,
    hasFreeListEnrichment: false,
    hasEventIntelligence: false,
  },
};

export default function EnrichmentConfig({ inputClasses, labelClasses, helperClasses }) {
  const { register, setValue } = useFormContext();
  const [enrichment] = useWatch({ name: ["enrichment"] });

  return (
    <div>
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
        <div className="flex items-center">
          <input
            {...register("enrichment.enabled")}
            id="enrichment-enabled"
            type="checkbox"
            checked={enrichment.enabled}
            onChange={(e) => setValue("enrichment.enabled", e.target.checked, { shouldDirty: true })
            }
            className="h-5 w-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <label htmlFor="enrichment-enabled" className="ml-3 text-sm font-semibold text-gray-900">
            Include enrichment credits in subscription
          </label>
        </div>
      </div>

      {enrichment.enabled ? (
        <>
          <div className="grid grid-cols-1 md: grid-cols-2 gap-4">
            <div>
              <label htmlFor="enrichment-credits" className={labelClasses}>
                Credits (preset)
              </label>
              <select
                {...register("enrichment.credits")}
                id="enrichment-credits"
                value={enrichment.credits}
                onChange={(e) => setValue("enrichment.credits", Number(e.target.value), { shouldDirty: true })
                }
                className={inputClasses}
              >
                {Object.keys(ENRICHMENT_PRESETS).map((k) => (
                  <option key={k} value={k}>
                    {Number(k).toLocaleString()} credits
                  </option>
                ))}
              </select>
              <p id="enrichment-credits-help" className={helperClasses}>
                Select a preset or choose custom
              </p>
            </div>
          </div>

          <div className="pt-4 border-t border-gray-200">
            <div className="flex items-center justify-between mb-3">
              <label className="block text-sm font-medium text-gray-900">
                Custom credit pricing
              </label>
              <div className="flex items-center">
                <input
                  {...register("enrichment.hasCustomPricing")}
                  id="enrichment-custom-pricing"
                  type="checkbox"
                  checked={enrichment.hasCustomPricing}
                  onChange={(e) => setValue("enrichment.hasCustomPricing", e.target.checked, { shouldDirty: true })
                  }
                  className="h-4 w-4 rounded border-gray-300 text-gray-900 focus:ring-gray-900"
                />
                <label
                  htmlFor="enrichment-custom-pricing"
                  className="ml-2 text-sm font-medium text-gray-700"
                >
                  Enable custom per credit pricing
                </label>
              </div>
            </div>

            {enrichment.hasCustomPricing ? (
              <div>
                <div className="relative">
                  <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                    $
                  </span>
                  <input
                    {...register("enrichment.dollars", {
                      valueAsNumber: true,
                    })}
                    id="enrichment-dollars"
                    type="number"
                    step="0.01"
                    min="0"
                    className={`${inputClasses} pl-7`}
                    placeholder="0.00"
                  />
                </div>
              </div>
            ) : (
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                <p className="text-sm text-gray-600">Using server default pricing for credits</p>
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
          <p className="text-sm text-gray-600">Enrichment credits are currently excluded.</p>
        </div>
      )}
    </div>
  );
}
